var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showStartPage)?_c('NewQuestion',{attrs:{"questions":_vm.questions,"crowd-survey":true}}):_c('StartedPageCrowd',{attrs:{"userName":_vm.userName},on:{"start-survey":_vm.startSurvey}})}
var staticRenderFns = []

export { render, staticRenderFns }